import { z } from 'zod'

export const GetStreamParser = z.object({
  eventId: z.number(),
  hlsUrl: z.string().optional(),
  hls: z.object({ url: z.string() }),
  posterUrl: z.string().optional(),
  statusCode: z.number()
})

export type Stream = z.infer<typeof GetStreamParser>
